import { TextInput } from '@core/components/Inputs';
import { formatCNPJ, formatCPF } from '@format';
import { Grid } from '@material-ui/core';
import { SelectUnidadeFederativa } from 'app/components/Select';
import { useFormikContext } from 'formik';
import React from 'react';

const FornecedorBuscaAvancadaForm = () => {
  const { values, handleChange, handleBlur } = useFormikContext();
  const { pessoa = {} } = values;
  const { uf } = pessoa.endereco || {};

  const getCpfCnpj = (values) => {
    if (values) {
      if (!/[a-zA-Z]/.test(values) && values?.length <= 14) {
        return formatCPF(values);
      } else {
        return formatCNPJ(values);
      }
    }
  };
  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={12}>
        <TextInput
          id="nome"
          nome="nome"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.nome}
          fullWidth
          variant="outlined"
          label="Nome"
          maxLength={100}
        />
      </Grid>

      <Grid item xs={12}>
        <TextInput
          id="razaoSocial"
          nome="razaoSocial"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.razaoSocial}
          fullWidth
          variant="outlined"
          label="Razão social"
          maxLength={100}
        />
      </Grid>

      <Grid item xs={12}>
        <TextInput
          id="cpfCnpj"
          nome="cpfCnpj"
          onChange={handleChange}
          onBlur={handleBlur}
          value={getCpfCnpj(values?.cpfCnpj)}
          fullWidth
          variant="outlined"
          label="CNPJ / CPF"
          maxLength={18}
        />
      </Grid>

      <Grid item xs={12}>
        <TextInput
          id="email"
          nome="email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.email}
          maxLength={100}
          fullWidth
          variant="outlined"
          label="E-mail"
        />
      </Grid>

      <Grid item xs={12}>
        <SelectUnidadeFederativa
          fullWidth
          variant="outlined"
          label="UF"
          id="pessoa.endereco.uf"
          idObject="pessoa.endereco.uf"
          value={uf && (uf.id || uf.nome || uf)}
          handleChange={handleChange}
        />
      </Grid>

      <Grid item xs={12}>
        <TextInput
          id="cidade"
          nome="cidade"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values?.cidade}
          fullWidth
          variant="outlined"
          label="Cidade"
          maxLength={100}
        />
      </Grid>
    </Grid>
  );
};

export default FornecedorBuscaAvancadaForm;
